// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/styles.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Configuration-module_options_card_qqGfN {
  min-height: 300px;
}

.Configuration-module_option_box_fGV9w > *:not(:first-child) {
  margin-left: 8px;
}

.Configuration-module_options_label_erH7P {
}

.Configuration-module_sub_label_PcB2v {
  margin-top: 4px !important;
}

.Configuration-module_year_selection_box_C__bQ {
  display: flex;
  gap: 2px;
}

.Configuration-module_clear_button_xqFaw {
}
`, "",{"version":3,"sources":["webpack://./src/client/pages/Configuration/Configuration.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;AAEA;;AAEA;EAEE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;AAEA","sourcesContent":[".options_card {\n  min-height: 300px;\n}\n\n.option_box > *:not(:first-child) {\n  margin-left: 8px;\n}\n\n.options_label {\n  composes: bos_label from 'Styles/styles.module.css';\n}\n\n.sub_label {\n  composes: bos_sub_label from 'Styles/styles.module.css';\n  margin-top: 4px !important;\n}\n\n.year_selection_box {\n  display: flex;\n  gap: 2px;\n}\n\n.clear_button {\n  composes: primary_button_minimal from 'Styles/styles.module.css';\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"options_card": `Configuration-module_options_card_qqGfN`,
	"option_box": `Configuration-module_option_box_fGV9w`,
	"options_label": `Configuration-module_options_label_erH7P ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bos_label"]}`,
	"sub_label": `Configuration-module_sub_label_PcB2v ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bos_sub_label"]}`,
	"year_selection_box": `Configuration-module_year_selection_box_C__bQ`,
	"clear_button": `Configuration-module_clear_button_xqFaw ${___CSS_LOADER_ICSS_IMPORT_0___.locals["primary_button_minimal"]}`
};
export default ___CSS_LOADER_EXPORT___;
